import React, { useContext } from 'react';
import { useSpectatorStatsV2 } from '../../hooks/spectators';
import { DataContext } from '../../context/data-context';
import { ALLSVENSKAN, SUPERETTAN } from '../../constants/leagues';

const getSecondLeague = (league) => {
  return league === ALLSVENSKAN ? SUPERETTAN : ALLSVENSKAN;
};

function SpectatorWidget() {
  const { currentSeason, league } = useContext(DataContext);
  const [primaryData] = useSpectatorStatsV2(league, currentSeason);

  const [secondaryData] = useSpectatorStatsV2(
    getSecondLeague(league),
    currentSeason
  );

  const primaryTotal = primaryData?.totalNumberOfSpectators ?? 0;
  const secondaryTotal = secondaryData?.totalNumberOfSpectators ?? 0;

  if (primaryData && secondaryData) {
    return (
      <div className="spectator-widget mt-5">
        <div className="row">
          <div className="col-12 col-md-6 mb-4 mb-md-0">
            <p className="heading-h6 mb-2 mt-0">
              PUBLIK {league.toUpperCase()} {currentSeason}
            </p>
            <div className="spectator-widget__count">
              {primaryData?.totalNumberOfSpectators.toLocaleString('sv')}
            </div>
          </div>
          <div className="col-12 col-md-6">
            <p className="heading-h6 mb-2 mt-0">
              PUBLIK {league.toUpperCase()} &{' '}
              {getSecondLeague(league).toUpperCase()} {currentSeason}
            </p>
            <div className="spectator-widget__count spectator-widget__count--black">
              {(primaryTotal + secondaryTotal).toLocaleString('sv')}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
}

export default SpectatorWidget;
